(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["card-slide"] && !Shopify.designMode) return;
  try {
    
  /*--------------------
Vars
--------------------*/
  let progress = 50;
  let startX = 0;
  let active = 0;
  let isDown = false;

  /*--------------------
Contants
--------------------*/
  const speedWheel = 0.02;
  const speedDrag = -0.1;

  /*--------------------
Get Z
--------------------*/
  const getZindex = (array, index) =>
    array.map((_, i) => (index === i ? array.length : array.length - Math.abs(index - i)));

  /*--------------------
Items
--------------------*/
  const $items = document.querySelectorAll('.cus-sd-carousel-item');

  const displayItems = (item, index, active) => {
    const zIndex = getZindex([...$items], active)[index];
    item.style.setProperty('--zIndex', zIndex);
    item.style.setProperty('--active', (index - active) / $items.length);
  };

  /*--------------------
Animate
--------------------*/
  const animate = () => {
    progress = Math.max(0, Math.min(progress, 100));
    active = Math.floor((progress / 100) * ($items.length - 1));

    $items.forEach((item, index) => displayItems(item, index, active));
  };
  animate();

  /*--------------------
Click on Items
--------------------*/
  $items.forEach((item, i) => {
    item.addEventListener('click', (e) => {
      // 如果不是激活卡片，阻止链接跳转，只切换卡片
      if (i !== active) {
        e.preventDefault();
        progress = $items.length > 1 ? (i / ($items.length - 1)) * 100 : 0;
        animate();
      }
      // 如果是激活卡片，让 <a> 标签正常跳转
    });
  });

  /*--------------------
Handlers
--------------------*/
  const handleWheel = (e) => {
    const wheelProgress = e.deltaY * speedWheel;
    progress = progress + wheelProgress;
    animate();
  };

  const handleMouseMove = (e) => {
    if (!isDown) return;
    const x = e.clientX || (e.touches && e.touches[0].clientX) || 0;
    const mouseProgress = (x - startX) * speedDrag;
    progress = progress + mouseProgress;
    startX = x;
    animate();
  };

  const handleMouseDown = (e) => {
    isDown = true;
    startX = e.clientX || (e.touches && e.touches[0].clientX) || 0;
  };

  const handleMouseUp = () => {
    isDown = false;
  };

  /*--------------------
Listeners
--------------------*/
  document.addEventListener('mousewheel', handleWheel);
  document.addEventListener('mousedown', handleMouseDown);
  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', handleMouseUp);
  document.addEventListener('touchstart', handleMouseDown);
  document.addEventListener('touchmove', handleMouseMove);
  document.addEventListener('touchend', handleMouseUp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hover-expand-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // 处理立即购买按钮
    const buyNowButtons = document.querySelectorAll('.hover-expand-grid__buy-now-button');
    buyNowButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const variantId = this.getAttribute('data-product-variant-id');
        if (!variantId) {
          alert('Product variant is missing');
          return;
        }

        const originalText = this.innerHTML;
        this.innerHTML = 'Processing...';
        this.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
        })
          .then((res) => (res.ok ? (window.location.href = '/checkout') : Promise.reject()))
          .catch(() => {
            alert('Error adding to cart');
            this.innerHTML = originalText;
            this.disabled = false;
          });
      });
    });

    // 处理加入购物车按钮
    const addCartButtons = document.querySelectorAll('.hover-expand-grid__add-cart-button');
    addCartButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const variantId = this.getAttribute('data-product-variant-id');
        if (!variantId) {
          alert('Product variant is missing');
          return;
        }

        const originalText = this.innerHTML;
        this.innerHTML = 'Adding...';
        this.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
        })
          .then((res) => {
            if (!res.ok) throw new Error();
            document.dispatchEvent(new Event('cart:refresh'));
            this.innerHTML = 'Added!';
            setTimeout(() => (this.innerHTML = originalText), 2000);
          })
          .catch(() => {
            alert('Error adding to cart');
            this.innerHTML = originalText;
          })
          .finally(() => (this.disabled = false));
      });
    });
  });

  document.querySelectorAll('.hover-expand-grid__product-link').forEach((link) => {
    let touchStartTime;

    link.addEventListener(
      'touchstart',
      function (e) {
        touchStartTime = Date.now();
        this.style.pointerEvents = 'none';
        this.getBoundingClientRect();
      },
      { passive: true }
    );

    link.addEventListener('touchend', function (e) {
      if (Date.now() - touchStartTime < 500) {
        requestAnimationFrame(() => {
          window.location.href = this.href;
        });
      }
      this.style.pointerEvents = 'auto';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-card-with-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const cards = document.querySelectorAll('.multi-card-feature-card');
  let activeOverlay = null;
  
  cards.forEach(card => {
    const openBtn = card.querySelector('.multi-card-btn-feature-card-open');
    const closeBtn = card.querySelector('.multi-card-btn-feature-card-close');
    const overlay = card.querySelector('.multi-card-feature-card-overlay');
    
    openBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      
      if (activeOverlay) {
        activeOverlay.classList.remove('active');
      }
      
      overlay.classList.add('active');
      activeOverlay = overlay;
      
      document.body.style.overflow = 'hidden';
    });
    
    closeBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      closeOverlay(overlay);
    });
    
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        closeOverlay(overlay);
      }
    });
  });
  
  function closeOverlay(overlay) {
    overlay.classList.remove('active');
    activeOverlay = null;
    
    document.body.style.overflow = '';
  }
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && activeOverlay) {
      closeOverlay(activeOverlay);
    }
  });
  
  document.addEventListener('click', function(e) {
    if (activeOverlay && !activeOverlay.contains(e.target)) {
      closeOverlay(activeOverlay);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ori-hover-expand-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Handle buy now buttons
    const buyNowButtons = document.querySelectorAll('.ori-hover-expand-grid__buy-now-button');
    buyNowButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const variantId = this.getAttribute('data-product-variant-id');
        if (!variantId) {
          alert('Product variant is missing');
          return;
        }

        const originalText = this.innerHTML;
        this.innerHTML = 'Processing...';
        this.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        })
        .then(res => res.ok ? window.location.href = '/checkout' : Promise.reject())
        .catch(() => {
          alert('Error adding to cart');
          this.innerHTML = originalText;
          this.disabled = false;
        });
      });
    });

    // Handle add to cart buttons
    const addCartButtons = document.querySelectorAll('.ori-hover-expand-grid__add-cart-button');
    addCartButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const variantId = this.getAttribute('data-product-variant-id');
        if (!variantId) {
          alert('Product variant is missing');
          return;
        }

        const originalText = this.innerHTML;
        this.innerHTML = 'Adding...';
        this.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        })
        .then(res => {
          if (!res.ok) throw new Error();
          document.dispatchEvent(new Event('cart:refresh'));
          this.innerHTML = 'Added!';
          setTimeout(() => this.innerHTML = originalText, 2000);
        })
        .catch(() => {
          alert('Error adding to cart');
          this.innerHTML = originalText;
        })
        .finally(() => this.disabled = false);
      });
    });
  });

  document.querySelectorAll('.ori-hover-expand-grid__product-link').forEach(link => {
    let touchStartTime;
    
    link.addEventListener('touchstart', function(e) {
      touchStartTime = Date.now();
      this.style.pointerEvents = 'none';
      
      this.getBoundingClientRect();
    }, { passive: true });

    link.addEventListener('touchend', function(e) {
      if (Date.now() - touchStartTime < 500) {
        requestAnimationFrame(() => {
          window.location.href = this.href;
        });
      }
      this.style.pointerEvents = 'auto';
    });
  });

  } catch(e) { console.error(e); }
})();
})();
